import styled from 'styled-components'
import AlertWithChildren from '../../components/common/alert/AlertWithChildren'

export const AlertStyled = styled(AlertWithChildren)`
  margin: 20px auto 18px;
  filter: ${(p) => (p.blur ? 'blur(2px)' : 'none')};
`
